import { render, staticRenderFns } from "./selectDropdown.vue?vue&type=template&id=810c35de&scoped=true&"
import script from "./selectDropdown.vue?vue&type=script&lang=js&"
export * from "./selectDropdown.vue?vue&type=script&lang=js&"
import style0 from "./selectDropdown.vue?vue&type=style&index=0&id=810c35de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810c35de",
  null
  
)

export default component.exports